// src/data/exercises/L6_06.js

const accountOptions = [
  '有価証券', '資本金', '普通預金', '支払手数料', '受取手数料'];

export const L6_06 = {
  title: '簿記　3級（第215-6回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
      content: {
     parts: [
    { "type": "ruby", "text": "愛知株式会社", "ruby": "あいちかぶしきがいしゃ" },
    { "type": "text", "value": "は、" },
    { "type": "ruby", "text": "三重株式会社", "ruby": "みえかぶしきがいしゃ" },
    { "type": "text", "value": "の" },
    { "type": "ruby", "text": "株式", "ruby": "かぶしき" },
    { "type": "text", "value": "1,000" },
    { "type": "ruby", "text": "株", "ruby": "かぶ" },
    { "type": "text", "value": "を１" },
    { "type": "ruby", "text": "株", "ruby": "かぶ" },
    { "type": "text", "value": "につき￥6,000で" },
    { "type": "ruby", "text": "購入", "ruby": "こうにゅう" },
    { "type": "text", "value": "し、その" },
    { "type": "ruby", "text": "代金", "ruby": "だいきん" },
    { "type": "text", "value": "は" },
    { "type": "ruby", "text": "証券会社", "ruby": "しょうけんがいしゃ" },
    { "type": "text", "value": "に" },
    { "type": "ruby", "text": "対", "ruby": "たい" },
    { "type": "text", "value": "する" },
    { "type": "ruby", "text": "購入手数料", "ruby": "こうにゅうてすうりょう" },
    { "type": "text", "value": "￥60,000とともに" },
    { "type": "ruby", "text": "普通預金口座", "ruby": "ふつうよきんこうざ" },
    { "type": "text", "value": "から" },
    { "type": "ruby", "text": "支払", "ruby": "しはら" },
    { "type": "text", "value": "った。" }
]

,
      },
      table: {
        options: accountOptions,
      },
      answer: [
        { debitAccount: '有価証券', debitAmount: 6060000, creditAccount: '普通預金', creditAmount: 6060000 },
      ],

      // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {
        parts: [
          { type: 'styled', value: '①「株式　購入し」→有価証券の増加（プラス）借方（左・Ｄｒ）\n\n', color: 'red', bold: true },
          { type: 'styled', value: '②「普通預金口座から」→普通預金の減少（マイナス）貸方（右・Ｃｒ）\n\n', color: 'red', bold: true },
          { type: 'text', value: '※株式1,000株を１株につき￥6,000で購入し/￥60,000とともに\n' },
          { type: 'text', value: '→1,000×6,000+60,000で計算する\n' },
         
        ]
      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
`

①「株式　購入し」→有価証券の増加（プラス）します。

②「普通預金口座から」→普通預金の減少（マイナス）します。

※株式1,000株を１株につき￥6,000で購入し/￥60,000とともに
→1,000×6,000+60,000で計算する


`,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {
           parts: [
          { type: 'styled', value: '①「株式　購入し」→有価証券の増加（プラス）借方（左・Ｄｒ）\n\n', color: 'red', bold: true },
          { type: 'styled', value: '②「普通預金口座から」→普通預金の減少（マイナス）貸方（右・Ｃｒ）\n\n', color: 'red', bold: true },
          { type: 'text', value: '※株式1,000株を１株につき￥6,000で購入し/￥60,000とともに\n' },
          { type: 'text', value: '→1,000×6,000+60,000で計算する\n' },
         
        ]
          }
        ],
       
        
      },
    },
  ],
};